import { focusStyles } from "@toolkit/Themes/common/mixins";

export default {
    defaultProps: {
        css: focusStyles(),
    },
};

